
window.__lazy_callback__ = function (lazyModule) {
  return class extends React.Component {
    state = {
      component: null,
    }
    componentWillMount() {
      lazyModule((module) => {
        if (typeof module.default === 'function') {
          this.setState({
            component: module.default,
          });
        } else {
          this.setState({
            component: module,
          });
        }
      });
    }
    render() {
      const Comp = this.state.component;
      return Comp ? <Comp {...this.props} /> : <div />;
    }
  };
}

import { combineReducers } from 'redux'
import * as common from './common/rendcer'
import * as box from './box/rendcer'

const Store = combineReducers({
  ...common,
  ...box
})

export default Store